import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

const NewPassWord = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const onSubmit = async () => {

    document.getElementById('my_modal_1').showModal()

  };
  return (

    <div>

      <div className="max-w-[1512px] px-12 w-full mx-auto flex  sm:justify-start justify-center items-center mt-6 min-h-[calc(100vh-184px)]">
      <div className='max-w-[382px] sm:max-w-[563px] w-full p-8 border-none rounded-md bg-white'>
        <div className='w-full'>
          <button className='flex gap-1 items-center mb-7 ml-[-4px] cursor-pointer' onClick={goBack}>
            <div className='max-w-[24px] w-full h-6'>
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18L9 12L15 6" stroke="#7D7D7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <p className='text-[#7D7D7D] font-rubik uppercase'>Back</p>
          </button>
          <p className='text-[32px] font-bebas uppercase mb-6 '>Reset Password</p>
          <form onSubmit={handleSubmit(onSubmit)} className='w-full'>
            <div className='max-w-[334px] sm:max-w-[499px] w-full mt-4'>
              <p className='font-montserrat text-base leading-8 font-medium'>New Password </p>
              <div className='rounded border h-[48px] justify-center items-center gap-2 py-2 px-4 flex'>
                <input type={showPassword1 ? "text" : "password"} className='w-full text-[#636363] font-medium border-none bg-transparent outline-none '
                  {...register("newPassword", {
                    required: {
                      value: true,
                      message: "Enter Your New Password",
                    },
                    minLength: {
                      value: 6,
                      message: "Password must be at least 6 characters long",
                    },
                  })}
                />
                <button className='max-w-[20px] w-full h-[14px] cursor-pointer' onClick={() => setShowPassword1(!showPassword1)}>
                  {
                    showPassword1 ? <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"></path></svg>
                      : <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968ZM5.9356 7.3497C4.60673 8.56015 3.6378 10.1672 3.22278 12.0002C4.14022 16.0521 7.7646 19.0002 12.0003 19.0002C13.5997 19.0002 15.112 18.5798 16.4243 17.8384L14.396 15.8101C13.7023 16.2472 12.8808 16.5002 12.0003 16.5002C9.51498 16.5002 7.50026 14.4854 7.50026 12.0002C7.50026 11.1196 7.75317 10.2981 8.19031 9.60442L5.9356 7.3497ZM12.9139 14.328L9.67246 11.0866C9.5613 11.3696 9.50026 11.6777 9.50026 12.0002C9.50026 13.3809 10.6196 14.5002 12.0003 14.5002C12.3227 14.5002 12.6309 14.4391 12.9139 14.328ZM20.8068 16.5925L19.376 15.1617C20.0319 14.2268 20.5154 13.1586 20.7777 12.0002C19.8603 7.94818 16.2359 5.00016 12.0003 5.00016C11.1544 5.00016 10.3329 5.11773 9.55249 5.33818L7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925ZM11.7229 7.50857C11.8146 7.50299 11.9071 7.50016 12.0003 7.50016C14.4855 7.50016 16.5003 9.51488 16.5003 12.0002C16.5003 12.0933 16.4974 12.1858 16.4919 12.2775L11.7229 7.50857Z"></path></svg>
                  }
                </button>
              </div>
              <label className="label">
                {errors.newPassword?.type === "required" && (
                  <span className="label-text-alt text-red-600">
                    {errors?.newPassword?.message}
                  </span>
                )}
                {errors.newPassword?.type === "minLength" && (
                  <span className="label-text-alt text-red-600">
                    {errors?.newPassword?.message}
                  </span>
                )}
              </label>
            </div>
            <div className='max-w-[334px] sm:max-w-[499px] w-full mt-4'>
              <p className='font-montserrat text-base leading-8 font-medium'>Confirm New Password</p>
              <div className='rounded border h-[48px] justify-center items-center gap-2 py-2 px-4 flex'>
                <input type={showPassword2 ? "text" : "password"} className='w-full text-[#636363] font-medium border-none bg-transparent outline-none '
                  {...register("confirmPassword", {
                    required: {
                      value: true,
                      message: "Enter Your Confirm Password",
                    },
                    minLength: {
                      value: 6,
                      message: "Password must be at least 6 characters long",
                    },
                  })}
                />
                <button className='max-w-[20px] w-full h-[14px] cursor-pointer' onClick={() => setShowPassword2(!showPassword2)}>
                  {
                    showPassword2 ? <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"></path></svg>
                      : <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968ZM5.9356 7.3497C4.60673 8.56015 3.6378 10.1672 3.22278 12.0002C4.14022 16.0521 7.7646 19.0002 12.0003 19.0002C13.5997 19.0002 15.112 18.5798 16.4243 17.8384L14.396 15.8101C13.7023 16.2472 12.8808 16.5002 12.0003 16.5002C9.51498 16.5002 7.50026 14.4854 7.50026 12.0002C7.50026 11.1196 7.75317 10.2981 8.19031 9.60442L5.9356 7.3497ZM12.9139 14.328L9.67246 11.0866C9.5613 11.3696 9.50026 11.6777 9.50026 12.0002C9.50026 13.3809 10.6196 14.5002 12.0003 14.5002C12.3227 14.5002 12.6309 14.4391 12.9139 14.328ZM20.8068 16.5925L19.376 15.1617C20.0319 14.2268 20.5154 13.1586 20.7777 12.0002C19.8603 7.94818 16.2359 5.00016 12.0003 5.00016C11.1544 5.00016 10.3329 5.11773 9.55249 5.33818L7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925ZM11.7229 7.50857C11.8146 7.50299 11.9071 7.50016 12.0003 7.50016C14.4855 7.50016 16.5003 9.51488 16.5003 12.0002C16.5003 12.0933 16.4974 12.1858 16.4919 12.2775L11.7229 7.50857Z"></path></svg>
                  }
                </button>
              </div>
              <label className="label">
                {errors.confirmPassword?.type === "required" && (
                  <span className="label-text-alt text-red-600">
                    {errors?.confirmPassword?.message}
                  </span>
                )}
                {errors.confirmPassword?.type === "minLength" && (
                  <span className="label-text-alt text-red-600">
                    {errors?.confirmPassword?.message}
                  </span>
                )}
              </label>
            </div>
            <input className='my-6 max-w-[132px] w-full h-[44px] cursor-pointer rounded-md text-white bg-[#A46E40] text-xl font-bebas leading-5' value="Save" type='submit' />
          </form>
        </div>
      </div>
      <dialog id="my_modal_1" className="modal">
        <div className="modal-box rounded-md p-12">
          <div className='max-w-[88px] w-full h-[88px] mx-auto '>
            <svg viewBox="0 0 89 88" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M81.1664 40.6473V44.0207C81.1618 51.9275 78.6015 59.6211 73.8672 65.954C69.133 72.2869 62.4784 76.9198 54.896 79.1616C47.3136 81.4035 39.2096 81.1343 31.7927 78.3941C24.3758 75.654 18.0434 70.5897 13.7399 63.9566C9.43632 57.3235 7.39224 49.4769 7.91249 41.5872C8.43274 33.6974 11.4894 26.1872 16.6267 20.1766C21.764 14.166 28.7066 9.97706 36.419 8.23453C44.1315 6.492 52.2007 7.28923 59.423 10.5073M81.1663 14.6663L44.4997 51.3697L33.4997 40.3697" stroke="#A46E40" strokeWidth="7.33333" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <p className="text-xl leading-8 font-rubik text-center text-[#1A1A1A] mx-auto my-[32px]">Your password has been changed successfully.</p>
          <div className="modal-action">
            <form method="dialog" className='flex justify-center items-center w-full'>
              <button onClick={() => navigate("/sign-in")} className="max-w-[166px] min-w-[166px] cursor-pointer mx-auto w-full h-11 font-rubik rounded-md text-[#fff] bg-[#A46E40]">Stay Logged In</button>
            </form>
          </div>
        </div>
      </dialog>
      </div>

    </div>
  );
};

export default NewPassWord;